import { render, staticRenderFns } from "./EmailDraftTable.vue?vue&type=template&id=06f2a5e2"
import script from "./EmailDraftTable.vue?vue&type=script&lang=js"
export * from "./EmailDraftTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports